export default "__VITE_ASSET__clZhB7Os__"